// Number of Warehouse Locations in Shopify configuration
export const LOCATIONS_COUNT = 3
